import {hmapPathParamConfig, hmapPathParamRegex} from "../../modules/hmap/hmap.routes.js";

export var OfferTemplatesRoutes = {
    "/brand/:brand_id/offer-templates": {
        "name": "appLayout.harriSH.offerTemplates",
        "type": "frontend",
        "component": 'offerTemplatesContainer',
        "route_dependencies": [
            {
                type: 'chunk',
                loader: function () {
                    return import("../../hmodules/offer-templates/offer-templates.module.js");
                }
            },
        ]
    },

    "/offer-templates": {
        "name": "appLayout.harriSH.access-portal.settings.offerTemplates",
        "type": "frontend",
        "abstract": true,
        "showSettingsHeader": true,
        "component": 'offerTemplatesContainer',
        "onEnter": ['$stateParams', '$state', 'hmapService', 'userPermissions', 'brandServices', async function ($stateParams, $state, hmapService, userPermissions, brandServices) {
            const activeBrandId = hmapService.getActiveBrandId($stateParams['hmapPath']);
            const [
                policyParser,
                isOnboardingEnabled
            ] = await Promise.all([
                userPermissions.getBrandPolicy(activeBrandId),
                brandServices.check(brandServices.SERVICES.ON_BOARDING, activeBrandId, true)
            ]);

            if (
                !policyParser.hasAccess(userPermissions.ACCESS_TYPES.SOURCE_HIRE) ||
                !policyParser.has(userPermissions.PERMISSIONS.MANAGE_OFFER_TEMPLATES) ||
                !isOnboardingEnabled
            ) {
                Utils.redirectToWorkspace('appLayout.harriSH.access-portal.main', {hmapPath: $stateParams['hmapPath']});
            }
            const gpPolicy = await hmapService.loadGPPlociy(activeBrandId);
            const activeBrandPolicy = gpPolicy?.brands?.find((entry) => entry.id === activeBrandId);

            if (activeBrandPolicy?.actions[0] !== 'ALL') {
                Utils.redirectToWorkspace('appLayout.harriSH.access-portal.main', {hmapPath: $stateParams['hmapPath']});
            }
        }
        ],
        "route_dependencies": [
            {
                type: 'chunk',
                loader: function () {
                    return import("../../hmodules/offer-templates/offer-templates.module.js");
                }
            },
        ]
    },

    "/manage": {
        "name": "appLayout.harriSH.offerTemplates.manage",
        "type": "frontend",
        "reloadOnSearch": false,
        "loginRequired": true,
        "showGlobalSearch": true,
        "views": {
            "offer-templates": {
                "component": 'offerTemplatesComponent',
            }
        },
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ['offer_templates', 'centralized-settings'],
        },
        "headTags": [
            {
                "tag": "title",
                "attributes": {},
                "value": "Harri | Offer Letter Templates"
            }
        ],
        "route_dependencies": []
    },

    [`/manage/${hmapPathParamRegex}`]: {
        "name": "appLayout.harriSH.access-portal.settings.offerTemplates.manage",
        "type": "frontend",
        "reloadOnSearch": false,
        "showSettingsHeader": true,
        "loginRequired": true,
        "params": {
            ...hmapPathParamConfig
        },
        "showGlobalSearch": true,
        "views": {
            "offer-templates": {
                "component": 'offerTemplatesComponent',
            }
        },
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ['offer_templates', 'centralized-settings'],
        },
        "headTags": [
            {
                "tag": "title",
                "attributes": {},
                "value": "Harri | Offer Letter Templates"
            }
        ],
        "route_dependencies": []
    },

    "/create?template_id?is_duplicate?is_settings": {
        "name": "appLayout.harriSH.offerTemplates.create",
        "type": "frontend",
        "reloadOnSearch": false,
        "loginRequired": true,
        "showGlobalSearch": true,
        "views": {
            "offer-templates": {
                "component": 'oneOfferTemplateComponent',
            }
        },
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ['offer_templates', 'centralized-settings'],
        },
        "route_dependencies": []
    },

    [`/create/${hmapPathParamRegex}?template_id&is_duplicate&is_settings`]: {
        "name": "appLayout.harriSH.access-portal.settings.offerTemplates.create",
        "type": "frontend",
        "reloadOnSearch": false,
        "loginRequired": true,
        "showGlobalSearch": true,
        "views": {
            "offer-templates": {
                "component": 'oneOfferTemplateComponent',
            }
        },
        "params": {
            ...hmapPathParamConfig
        },
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ['offer_templates', 'centralized-settings'],
        },
        "route_dependencies": []
    },

    "/brand/:brand_id/job-templates?tab": {
        "name": "appLayout.harriSH.jobTemplates",
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ["job-screening-templates", 'centralized-settings']
        },
        "route_dependencies": [
            {
                type: 'chunk',
                loader: function () {
                    return import("../../hmodules/offer-templates/offer-templates.module.js");
                }
            },
            {
                type: 'chunk',
                loader: function () {
                    return import("../../hmodules/on-boarding/on-boarding.module.js");
                }
            },
            {
                type: 'chunk',
                loader: () => {
                    return import("../../hmodules/job-templates/job-templates.module.js");
                }
            }
        ]
    },
    "/brand/:brand_id/crm?tab": {
        "route_dependencies": [
            {
                type: 'chunk',
                loader: function () {
                    return import("../../hmodules/offer-templates/offer-templates.module.js");
                }
            }
        ]
    },
    "/brand/:brand_id/interview-invite": {
        "route_dependencies": [
            {
                type: 'chunk',
                loader: () => {
                    return import("../../hmodules/offer-templates/offer-templates.module.js");
                }
            }
        ]
    },
    "/email/create?email_id&brand_id&source": {
        "route_dependencies": [
            {
                type: 'chunk',
                loader: function () {
                    return import("../../hmodules/offer-templates/offer-templates.module.js");
                }
            }
        ]
    },
    "/campaign/create?campaign_id&brand_id&source": {
        "route_dependencies": [
            {
                type: 'chunk',
                loader: function () {
                    return import("../../hmodules/offer-templates/offer-templates.module.js");
                }
            }
        ]
    },
};
